import { criticalData } from "../pages/reports/critical_format";

export const getRiskCriticalContext = (value) => {
  switch (value) {
    case 5:
      return criticalData["critical"];
    case 4:
      return criticalData["very_high"];

    case 3:
      return criticalData["high"];

    case 2:
      return criticalData["moderate"];
    default:
      return criticalData["acceptable"];
  }
};

export const getGlobalCriticalContext = (score) => {
  let critical = {};
  switch (true) {
    case score >= 9:
      critical = criticalData["critical"];
      break;
    case score < 9 && score >= 7:
      critical = criticalData["very_high"];
      break;
    case score < 7 && score >= 5:
      critical = criticalData["high"];
      break;
    case score < 5 && score >= 3:
      critical = criticalData["moderate"];
      break;
    default:
      critical = criticalData["acceptable"];
      break;
  }
  return critical;
};
